export default __webpack_public_path__ + "static/media/menShortTrousers.204a8424.svg";